(function () {
  var GAP = 24; // breathing room below the header

  function stickyHeaderHeight() {
    var h = document.querySelector('header.header__wrapper.sticky--active');
    return h ? h.offsetHeight : 0;
  }

  document.querySelectorAll('.toc-list a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - stickyHeaderHeight() - GAP;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      history.pushState(null, '', '#' + id);
    });
  });
})();
